import React from "react";
import { isIOS } from "../utils/platformUtils";

const APP_STORE_URL = "https://apps.apple.com/app/id6779376206";

function AppStoreBadge() {
  if (!isIOS()) return null;

  return (
    <a
      href={APP_STORE_URL}
      className="dynerz-appstore-badge"
      aria-label="Download dyner.z on the App Store"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* U+F8FF renders as the Apple logo in Apple's system fonts only —
          fine here since this badge is only shown to iOS users. */}
      <span className="dynerz-appstore-badge-glyph" aria-hidden="true">
        {""}
      </span>
      <span className="dynerz-appstore-badge-text">
        <span className="dynerz-appstore-badge-small">Download on the</span>
        <span className="dynerz-appstore-badge-large">App Store</span>
      </span>
    </a>
  );
}

export default AppStoreBadge;
